import React from "react";

import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import Platform from "./Platform";

import style from "./style.module.css";

export default function MembershipBenefits(props) {
    const {
        title,
        tag,
        subtitle,
        platforms = []
    } = props;

    return (
        <Section className={`${style.membershipBenefits}`}>
            {
                title && (
                    <>
                        <Title
                            className="fontTeko"
                            tag={tag}
                            transform="textUpperCase"
                        >
                            {title}
                        </Title>
                    </>
                )
            }
            {
                subtitle && (
                    <>
                        <Spacer size={"24"} />
                        <Title
                            tag={"h3"}
                            className="fontTeko"
                        >
                            {subtitle}
                        </Title>
                    </>
                )
            }
            {
                platforms.length > 0 && (
                    <ul className={style.platforms}>
                        {
                            platforms.map((item, idx) => (
                                <Platform key={`platform_${idx}`} details={item} />
                            ))
                        }
                    </ul>
                )
            }
        </Section>
    )
};